// Layout.jsx
import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';

function Layout({ children }) {
  const [collapsed, setCollapsed] = useState(true); // true = fechada no mobile

  const toggleSidebar = () => {
    setCollapsed((prev) => !prev);
  };

  return (
    <div className="app-container">
      <Sidebar collapsed={collapsed} toggleSidebar={toggleSidebar} />
      <div className="main-content">
        <Header toggleSidebar={toggleSidebar} /> {/* ← passa o toggle pro header */}
        <main className="bg-light" style={{ minHeight: 'calc(100vh - 56px)' }}>
          {children}
        </main>
      </div>
    </div>
  );
}

export default Layout;
